import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import {
  Modal, Container, Rating, Button,
  Header, Form,
} from 'semantic-ui-react';
import { REVIEW_MEETING } from '../../queries/meeting';

const RATING_TEXTS = ['', 'Awful, not what I expected at all',
  'Poor, pretty disappointed', 'Average, could be better',
  'Good, what I expected', 'Amazing, above expectations!'];

const ReviewModal = ({ meeting, children }) => {
  const hasReviewed = !!meeting.ratingOnExpert || !!meeting.reviewOnExpert;
  const [rating, setRating] = useState(meeting.ratingOnExpert || 0);
  const [comment, setComment] = useState(meeting.reviewOnExpert || '');
  const [open, setOpen] = useState(false);

  const [reviewMeeting] = useMutation(REVIEW_MEETING);

  const onSubmit = () => {
    reviewMeeting({
      variables: {
        userId: meeting.expert.id,
        projectId: meeting.project.id,
        job: {
          ratingOnExpert: rating,
          reviewOnExpert: comment,
        },
      },
    });
    setOpen(false);
  };

  const onClose = () => {
    // Reset to original values if user cancels out of editing
    setRating(meeting.ratingOnExpert || 0);
    setComment(meeting.reviewOnExpert || '');
    setOpen(false);
  };

  return (
    <Modal
      closeIcon
      open={open}
      onOpen={() => setOpen(true)}
      onClose={onClose}
      trigger={children}
      id="review-modal"
    >
      <Modal.Header>{hasReviewed ? 'Edit Review' : 'Leave a Review'}</Modal.Header>
      <Modal.Content>
        <Header>{`How would you rate your experience with ${meeting.expert.fullName}?`}</Header>
        <Container textAlign="center">
          <Header>{RATING_TEXTS[rating]}</Header>
          <Rating
            icon="star"
            rating={rating}
            maxRating={5}
            onRate={(e, data) => setRating(data.rating)}
          />
        </Container>
        <Form>
          <Form.TextArea
            label={`Please briefly share your experience with ${meeting.expert.fullName}`}
            value={comment}
            onInput={(e, { value }) => setComment(value)}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button className="basic-btn" onClick={onClose}>
          Cancel
        </Button>
        <Button
          className="primary-btn"
          onClick={onSubmit}
          disabled={rating === 0 || comment.trim() === ''}
        >
          Submit review
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ReviewModal;
